<div id="summary-info-elements">
  @if (coverage?.withCoverage !== null && coverage?.withCoverage !== undefined) {
    <div>
      <span i18n>Couverture</span>
      <span
        [ngClass]="{
          'summary-badge': true,
          'summary-badge-success': coverage?.withCoverage
        }"
        >{{ getBooleanLabel(coverage?.withCoverage) }}</span
      >
    </div>
  }
  @if (coverage?.insuredSum !== undefined) {
    <div class="row">
      <div class="col">
        <label>{{ insuredSumLabel }}</label>
        <input type="text" disabled [value]="coverage?.insuredSum" />
      </div>
    </div>
  }
  @if (coverage?.deductible !== undefined) {
    <div class="row">
      <div class="col">
        <label>{{ deductibleLabel }}</label>
        <input type="text" disabled [value]="coverage?.deductible" />
      </div>
    </div>
  }
</div>
